module.exports = __webpack_public_path__ + "img/3.52490213.jpg";